import { createContext, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setSelectedTemplate } from '../features/examTemplate/examTemplateSlice';

const ExamTemplateContext = createContext();

export const ExamTemplateProvider = ({ children }) => {
  const { selectedTemplate } = useSelector(state => state.examTemplate);
  const dispatch = useDispatch();

  const setExamTemplate = (template) => dispatch(setSelectedTemplate(template));

  return (
    <ExamTemplateContext.Provider value={{ 
      selectedTemplate, 
      setExamTemplate
    }}>
      {children}
    </ExamTemplateContext.Provider>
  );
};

export const useExamTemplate = () => {
  const context = useContext(ExamTemplateContext);
  if (!context) {
    throw new Error('useExamTemplate must be used within an ExamTemplateProvider');
  }
  return context;
};
